module.exports = __webpack_public_path__ + "img/es.045b86a1.svg";